<div (click)="closeDropdown()" class="px-4">
  <app-header />

  <div>
    <app-filter
      [filters]="filters()"
      [statuses]="statuses()"
      (toggleSortOrder)="toggleSortOrder()"
      (resetFilters)="resetFilters()"
      (applyFilters)="applyFilters($event)" />
  </div>

  @if (errorPharmacies() && !loadingPharmacies()) {
    <div class="flex flex-col items-center justify-center py-20 text-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
        <svg class="h-8 w-8 text-red-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v2m0 4h.01M10.29 3.86l-8.58 14.86A2 2 0 003.42 22h17.16a2 2 0 001.71-3.28L13.71 3.86a2 2 0 00-3.42 0z" />
        </svg>
      </div>

      <h2 class="mt-6 text-xl font-semibold text-gray-800">
        {{ isArabic() ? "تعذر تحميل الصيدليات" : "Failed to load pharmacies" }}
      </h2>

      <p class="mt-2 max-w-md text-sm text-gray-500">
        {{ errorPharmacies() }}
      </p>

      <button
        (click)="loadPharmacies()"
        class="bg-primary hover-bg-primary-hover mt-6 cursor-pointer rounded-lg px-5 py-2 text-sm font-medium text-white transition">
        {{ isArabic() ? "إعادة المحاولة" : "Try Again" }}
      </button>
    </div>
  }

  @if (loadingPharmacies()) {
    <app-loading />
  } @else {
    @if (pharmacies() && pharmacies()?.length === 0 && !loadingPharmacies() && !errorPharmacies()) {
      <div class="flex w-full flex-col items-center justify-center py-12 text-center">
        @if (filterSubmitted()) {
          <p class="text-lg font-medium text-gray-500" i18n="@@userPharmaciesNoResults">
            No pharmacies found matching your filters.
          </p>
          <p class="text-sm text-gray-400" i18n="@@userPharmaciesNoResultsHint">
            Try adjusting or resetting your filters.
          </p>
        }
        @if (!filterSubmitted()) {
          <app-no-pharmacies />
        }
      </div>
    } @else {
      <div class="grid grid-cols-3 gap-4 pb-6">
        @for (pharmacy of pharmacies(); track pharmacy.id; let i = $index; let count = $count) {
          <div
            (click)="onNavigateToPharmacyRequestDetails(pharmacy.id)"
            class="flex cursor-pointer flex-col gap-4 rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <div class="flex items-start justify-between">
              <div class="flex flex-col gap-2">
                <h3 class="text-xl font-bold text-black">
                  {{ pharmacy.nickName.length > 20 ? pharmacy.nickName.slice(1, 20) + "..." : pharmacy.nickName }}
                </h3>
                <div class="flex flex-wrap gap-2">
                  <span
                    class="flex min-w-28 items-center justify-center gap-1.5 rounded-full px-3 py-1 text-center text-xs font-medium"
                    [class]="getStatusClass(pharmacy.status)">
                    @if (pharmacy.status.titleEn.toLowerCase() == "pending") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "in progress") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                        <path d="M3 3v5h5" />
                        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                        <path d="M16 21h5v-5" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "accepted") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "rejected") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="15" y1="9" x2="9" y2="15" />
                        <line x1="9" y1="9" x2="15" y2="15" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "expired") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "feedback needed") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      </svg>
                    }
                    @if (pharmacy.status.titleEn.toLowerCase() == "cancelled") {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <line x1="4.93" y1="19.07" x2="19.07" y2="4.93" />
                      </svg>
                    }
                    <span>{{ getLocalizedTitle(pharmacy.status) }}</span>
                  </span>
                </div>
              </div>
              <div class="relative" (click)="$event.stopPropagation()">
                <button
                  (click)="toggleDropdown($event, pharmacy.id)"
                  class="text-gray-600 hover:cursor-pointer hover:text-gray-800">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M12 16a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2m0-6a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2" />
                  </svg>
                </button>
                @if (activeDropdownId() === pharmacy.id) {
                  <div
                    [class.top-full]="i < count - 2"
                    [class.mt-1]="i < count - 2"
                    [class.bottom-full]="i >= count - 2"
                    [class.mb-1]="i >= count - 2"
                    [class]="isArabic() ? 'left-[40%]' : 'right-[40%]'"
                    class="absolute z-50 flex w-48 flex-col gap-1 rounded-md border border-gray-200 bg-white p-1 shadow-lg">
                    @for (action of currentActions(); track action.id) {
                      <button
                        (click)="handleAction($event, action.id, pharmacy)"
                        class="w-full rounded-[4px] px-3 py-2 text-left text-[13px] text-gray-700 hover:cursor-pointer hover:bg-gray-50">
                        {{ isArabic() ? action.titleAr : action.titleEn }}
                      </button>
                    }
                  </div>
                }
                <!-- @if (openDropdownId() == pharmacy.id) {
                  <div
                    class="absolute top-8 z-50 min-w-[180px] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl ltr:right-0 rtl:left-0">
                    @if (loadingActions()) {
                      <div class="px-4 py-2 text-sm text-gray-500" i18n="@@loadingActions">Loading actions...</div>
                    } @else {
                      @for (action of currentActions(); track action) {
                        <button
                          (click)="handleAction(action, pharmacy.id)"
                          class="flex w-full items-center gap-2 px-3 py-1.5 font-['Inter'] text-[12px] font-medium text-neutral-800 transition-colors hover:cursor-pointer hover:bg-gray-100 ltr:text-left rtl:text-right">
                          @if (action.titleEn === "View Pharmacy Details") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                              <circle cx="12" cy="12" r="3" />
                            </svg>
                          } @else if (action.titleEn === "Edit Pharmacy") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
                            </svg>
                          } @else if (action.titleEn === "Assign Manager") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                              <circle cx="8.5" cy="7" r="4" />
                              <line x1="20" y1="8" x2="20" y2="14" />
                              <line x1="23" y1="11" x2="17" y2="11" />
                            </svg>
                          } @else if (action.titleEn === "Revoke Manager") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                              <circle cx="8.5" cy="7" r="4" />
                              <line x1="18" y1="8" x2="23" y2="13" />
                              <line x1="23" y1="8" x2="18" y2="13" />
                            </svg>
                          } @else if (action.titleEn === "Cancel Request" || action.titleEn === "Cancel Pharmacy") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <circle cx="12" cy="12" r="10" />
                              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                            </svg>
                          } @else if (action.titleEn === "Submit Modification") {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <line x1="22" y1="2" x2="11" y2="13" />
                              <polygon points="22 2 15 22 11 13 2 9 22 2" />
                            </svg>
                          } @else {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round">
                              <circle cx="12" cy="12" r="1" />
                              <circle cx="19" cy="12" r="1" />
                              <circle cx="5" cy="12" r="1" />
                            </svg>
                          }

                          <span>{{ getLocalizedTitle(action) }}</span>
                        </button>
                      }
                    }
                  </div>
                } -->
              </div>
            </div>
            <div class="flex items-end justify-between">
              <span class="text-xl font-bold text-black">#{{ pharmacy.id }}</span>
              <div class="flex flex-col items-end text-right">
                <span class="text-xs text-gray-500">{{ pharmacy.lastModifiedOn | date }}</span>
                <span class="text-xs text-gray-500">{{ pharmacy?.lastModifiedBy?.fullName }}</span>
              </div>
            </div>
          </div>
        }
      </div>

      @if (totalPages() > 1) {
        <div class="flex items-center justify-center gap-3 py-6">
          <button
            (click)="prevPage()"
            [disabled]="currentPage() === 0"
            [class]="currentPage() === 0 ? 'cursor-not-allowed' : 'cursor-pointer'"
            class="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline [attr.points]="isArabic() ? '9 18 15 12 9 6' : '15 18 9 12 15 6'" />
            </svg>
          </button>

          @for (page of totalPagesArray(); track page) {
            <button
              (click)="goToPage(page)"
              [class]="
                page === currentPage()
                  ? 'bg-primary h-9 w-9 cursor-not-allowed rounded-lg text-sm font-semibold text-white shadow-sm'
                  : 'h-9 w-9 cursor-pointer rounded-lg border border-gray-200 bg-white text-sm text-gray-600 shadow-sm transition hover:bg-gray-50'
              ">
              {{ page + 1 }}
            </button>
          }

          <button
            (click)="nextPage()"
            [disabled]="currentPage() + 1 >= totalPages()"
            [class]="currentPage() + 1 >= totalPages() ? 'cursor-not-allowed' : 'cursor-pointer'"
            class="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <polyline [attr.points]="isArabic() ? '15 18 9 12 15 6' : '9 18 15 12 9 6'" />
            </svg>
          </button>
        </div>
      }
    }
  }

  <!-- @if (assigningManagerId()) {
    <app-assign-manager-dialog
      [pharmacyId]="assigningManagerId()!"
      [nickname]="assigningManagerName()!"
      (close)="closeAssignManagerDialog()"
      (save)="onManagerAssigned($event)" />
  }
  @if (revokingManagerId()) {
    <app-revoke-manager-dialog
      [managerName]="revokingManagerName()!"
      (close)="closeRevokeManagerDialog()"
      (confirm)="onManagerRevoked()" />
  } -->
  @if (cancelingPharmacyId()) {
    <app-cancel-pharmacy-dialog
      [errorCancel]="errorCancel()"
      [loadingCancel]="loadingCancel()"
      [pharmacyName]="cancelingPharmacyName()!"
      (close)="closeCancelDialog()"
      (confirm)="onRequestCancelled()"
      [pharmacyRequestId]="pharmacyRequestId()" />
  }
</div>
